/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/lectures.
 */

export interface CmsLectureIndexEntry {
  slug: string
  audience: string
  speaker: string
  event_date: string
  title: string
  summary: string
  title_zhHant: string
  title_zhHans: string
  title_en: string
  summary_zhHant: string
  summary_zhHans: string
  summary_en: string
  host_zhHant: string
  host_zhHans?: string
  host_en: string
  venue_zhHant: string
  venue_zhHans?: string
  venue_en: string
  series_zhHant: string
  series_zhHans?: string
  series_en: string
  photo1_url: string
  photo1_width: number | null
  photo1_height: number | null
  photo1_alt_zhHant: string
  photo1_alt_zhHans?: string
  photo1_alt_en: string
  photo2_url: string
  photo2_width: number | null
  photo2_height: number | null
  photo2_alt_zhHant: string
  photo2_alt_zhHans?: string
  photo2_alt_en: string
  meta_title_zhHant?: string | null
  meta_title_zhHans?: string | null
  meta_title_en?: string | null
  meta_description_zhHant?: string | null
  meta_description_zhHans?: string | null
  meta_description_en?: string | null
  external_url: string | null
  venue_url: string | null
  published_at: number | null
}

export const cmsLectures: CmsLectureIndexEntry[] = [
  {
    "slug": "https-www-apsw-edu-hk",
    "audience": "parent",
    "speaker": "魏遠強（YADA行政總監）",
    "event_date": "2026-10-24",
    "title": "在AI時代陪伴孩子活出健康的數位生活 - 黃埔宣道小學講座",
    "summary": "日期: 2026.10.24\n感謝黃埔宣道小學  李校長邀請，為家長分享「在AI時代陪伴孩子活出健康的數位生活」的題目。學校的熱心及家長的關心，令這週末變成了最好的教養討論時機。\n",
    "title_zhHant": "在AI時代陪伴孩子活出健康的數位生活 - 黃埔宣道小學講座",
    "title_zhHans": "在AI时代陪伴孩子活出健康的数位生活 - 黄埔宣道小学讲座",
    "title_en": "Living a Healthy Digital Life with Children in the AI Era - Alliance Primary School, Whampoa",
    "summary_zhHant": "日期: 2026.10.24\n感謝黃埔宣道小學  李校長邀請，為家長分享「在AI時代陪伴孩子活出健康的數位生活」的題目。學校的熱心及家長的關心，令這週末變成了最好的教養討論時機。\n",
    "summary_zhHans": "日期: 2026.10.24\n感谢黄埔宣道小学  李校长邀请，为家长分享「在AI时代陪伴孩子活出健康的数位生活」的题目。学校的热心及家长的关心，令这周末变成了最好的教养讨论时机。\n",
    "summary_en": "Date: 2026.10.24\nThanks to Principal Li of Alliance Primary School, Whampoa for inviting us to share the topic 「Living a Healthy Digital Life with Children in the AI Era」 with the parents. The school's hospitality and the parents' concern made this weekend the ideal occasion for a discussion on parenting.",
    "host_zhHant": "黃埔宣道小學",
    "host_zhHans": "黄埔宣道小学",
    "host_en": "Alliance Primary School, Whampoa",
    "venue_zhHant": "黃埔宣道小學禮堂",
    "venue_zhHans": "黄埔宣道小学礼堂",
    "venue_en": "",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/95bbb3ae-2b38-476e-92be-ce4c05fb52d0.medium.webp",
    "photo1_width": 1378,
    "photo1_height": 775,
    "photo1_alt_zhHant": "",
    "photo1_alt_zhHans": "",
    "photo1_alt_en": "",
    "photo2_url": "/uploads/2026-10/a8f56618-1aeb-4a0f-bb7c-d66a35686b1d.medium.webp",
    "photo2_width": 1380,
    "photo2_height": 1035,
    "photo2_alt_zhHant": "",
    "photo2_alt_zhHans": "",
    "photo2_alt_en": "",
    "meta_title_zhHant": null,
    "meta_title_zhHans": null,
    "meta_title_en": null,
    "meta_description_zhHant": null,
    "meta_description_zhHans": null,
    "meta_description_en": null,
    "external_url": null,
    "venue_url": "https://www.apsw.edu.hk/",
    "published_at": 1792988263786
  },
  {
    "slug": "hktdc-electronics-fair-20261013",
    "audience": "teacher",
    "speaker": "魏遠強（YADA行政總監）",
    "event_date": "2026-10-13",
    "title": "YADA行政總監於香港貿發局電子產品展分享青年創業觀察：創業者與投資者的思維差距",
    "summary": "YADA行政總監魏遠強先生獲邀出席香港貿易發展局主辦的電子產品展，就「創業者與投資者的思維差距」分享對青年創業的觀察與見解，論壇由天使投資基金會主席沈偉銓先生主持。",
    "title_zhHant": "YADA行政總監於香港貿發局電子產品展分享青年創業觀察：創業者與投資者的思維差距",
    "title_zhHans": "YADA行政总监于香港贸发局电子产品展分享青年创业观察：创业者与投资者的思维差距",
    "title_en": "YADA Executive Director Shares Youth Entrepreneurship Observations at HKTDC Electronics Fair: The Mindset Gap Between Entrepreneurs and Investors",
    "summary_zhHant": "YADA行政總監魏遠強先生獲邀出席香港貿易發展局主辦的電子產品展，就「創業者與投資者的思維差距」分享對青年創業的觀察與見解，論壇由天使投資基金會主席沈偉銓先生主持。",
    "summary_zhHans": "YADA行政总监魏远强先生获邀出席香港贸易发展局主办的电子产品展，就「创业者与投资者的思维差距」分享对青年创业的观察与见解，论坛由天使投资基金会主席沈伟铨先生主持。",
    "summary_en": "Mr. Wai Yuen-keung, Administrative Director of YADA, was invited to attend the Electronics Fair organized by the Hong Kong Trade Development Council to share his observations and insights on youth entrepreneurship in a session titled \"The Mindset Gap Between Entrepreneurs and Investors.\" The forum was moderated by Mr. Shim Wai-chuen, Chairman of the Angel Investment Foundation.",
    "host_zhHant": "天使投資基金會",
    "host_zhHans": "天使投资基金会",
    "host_en": "Angel Investors Foundation",
    "venue_zhHant": "香港貿易發展局電子產品展",
    "venue_zhHans": "香港贸易发展局电子产品展",
    "venue_en": "Hong Kong Trade Development Council Electronics Fair",
    "series_zhHant": "初創專區 IP ZONE",
    "series_zhHans": "初创专区 IP ZONE",
    "series_en": "Startup Zone IP ZONE",
    "photo1_url": "/uploads/2026-10/180836d8-e2bd-4163-863a-5221aab56b96.medium.webp",
    "photo1_width": 710,
    "photo1_height": 473,
    "photo1_alt_zhHant": "講者手持咪高峰分享觀點，背景可見「IP ZONE 初創專區」活動標識",
    "photo1_alt_zhHans": "讲者手持咪高峰分享观点，背景可见「IP ZONE 初创专区」活动标识",
    "photo1_alt_en": "The speaker holds a microphone while sharing their views, with the \"IP ZONE Startup Zone\" event signage visible in the background.",
    "photo2_url": "/uploads/2026-10/575ee28a-39da-4970-8c8c-dd006c12919f.medium.webp",
    "photo2_width": 833,
    "photo2_height": 555,
    "photo2_alt_zhHant": "與會者交流討論環節",
    "photo2_alt_zhHans": "与会者交流讨论环节",
    "photo2_alt_en": "Attendees engaging in discussion during the forum.",
    "meta_title_zhHant": "YADA行政總監於香港貿發局電子產品展分享青年創業觀察：創業者與投資者的思維差距",
    "meta_title_zhHans": "YADA行政总监于香港贸发局电子产品展分享青年创业观察：创业者与投资者的思维差距",
    "meta_title_en": "Youth Entrepreneurship at HKTDC Electronics Fair",
    "meta_description_zhHant": "YADA行政總監魏遠強先生獲邀出席香港貿易發展局主辦的電子產品展，就「創業者與投資者的思維差距」分享對青年創業的觀察與見解，論壇由天使投資基金會主席沈偉銓先生主持。",
    "meta_description_zhHans": "YADA行政总监魏远强先生获邀出席香港贸易发展局主办的电子产品展，就「创业者与投资者的思维差距」分享对青年创业的观察与见解，论坛由天使投资基金会主席沈伟铨先生主持。",
    "meta_description_en": "YADA's Mr. Wai shared observations on the mindset gap between young entrepreneurs and investors at the HKTDC Electronics Fair.",
    "external_url": null,
    "venue_url": null,
    "published_at": 1793286099274
  },
  {
    "slug": "shenzhen-dse-jupas-20261011",
    "audience": "parent",
    "speaker": "魏遠強（YADA 行政總監）",
    "event_date": "2026-10-11",
    "title": "深圳升學講座：DSE 制度與 JUPAS 策略全解",
    "summary": "YADA 行政總監魏遠強前往深圳，為香港學生及家長講解 DSE 報考要求、科目組合與評分機制，並分析 JUPAS 選科策略及注意事項，協助跨境家庭盡早規劃升學路向，填補長久以來的升學資訊缺口。",
    "title_zhHant": "深圳升學講座：DSE 制度與 JUPAS 策略全解",
    "title_zhHans": "深圳升学讲座：DSE 制度与 JUPAS 策略全解",
    "title_en": "Shenzhen Study Pathway Lecture: A Complete Guide to the DSE System and JUPAS Strategy",
    "summary_zhHant": "YADA 行政總監魏遠強前往深圳，為香港學生及家長講解 DSE 報考要求、科目組合與評分機制，並分析 JUPAS 選科策略及注意事項，協助跨境家庭盡早規劃升學路向，填補長久以來的升學資訊缺口。",
    "summary_zhHans": "YADA 行政总监魏远强前往深圳，为香港学生及家长讲解 DSE 报考要求、科目组合与评分机制，并分析 JUPAS 选科策略及注意事项，协助跨境家庭尽早规划升学路向，填补长久以来的升学资讯缺口。",
    "summary_en": "YADA Executive Director Wei Yuanqiang travelled to Shenzhen to explain DSE registration requirements, subject combinations and scoring mechanisms to Hong Kong students and parents, and to analyse JUPAS subject selection strategies and key considerations, helping cross-border families plan their study pathways early and bridging the long-standing gap in study-pathway information.",
    "host_zhHant": "青年耀進發展協會",
    "host_zhHans": "青年耀进发展协会",
    "host_en": "Youth Advancement Development Association",
    "venue_zhHant": "深圳",
    "venue_zhHans": "深圳",
    "venue_en": "Shenzhen",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/56dc0b3d-bdde-4533-893a-633e8dd98d98.medium.webp",
    "photo1_width": 1380,
    "photo1_height": 1035,
    "photo1_alt_zhHant": "深圳 DSE 與 JUPAS 升學講座現場",
    "photo1_alt_zhHans": "深圳 DSE 与 JUPAS 升学讲座现场",
    "photo1_alt_en": "Lecture in Shenzhen on DSE and JUPAS study pathways.",
    "photo2_url": "",
    "photo2_width": null,
    "photo2_height": null,
    "photo2_alt_zhHant": "",
    "photo2_alt_zhHans": "",
    "photo2_alt_en": "",
    "meta_title_zhHant": "深圳升學講座：DSE 制度與 JUPAS 策略全解",
    "meta_title_zhHans": "深圳升学讲座：DSE 制度与 JUPAS 策略全解",
    "meta_title_en": "Shenzhen DSE & JUPAS Strategy Briefing",
    "meta_description_zhHant": "YADA 行政總監魏遠強前往深圳，為香港學生及家長講解 DSE 報考要求、科目組合與評分機制，並分析 JUPAS 選科策略及注意事項，協助跨境家庭盡早規劃升學路向，填補長久以來的升學資訊缺口。",
    "meta_description_zhHans": "YADA 行政总监魏远强前往深圳，为香港学生及家长讲解 DSE 报考要求、科目组合与评分机制，并分析 JUPAS 选科策略及注意事项，协助跨境家庭尽早规划升学路向，填补长久以来的升学资讯缺口。",
    "meta_description_en": "YADA's Wei Yuanqiang briefed Hong Kong students and parents in Shenzhen on DSE registration, subject choices, scoring, and JUPAS strategy.",
    "external_url": null,
    "venue_url": null,
    "published_at": 1791938252043
  },
  {
    "slug": "asbury-methodist-20261009",
    "audience": "parent",
    "speaker": "魏遠強（YADA 行政總監）",
    "event_date": "2026-10-09",
    "title": "讓 AI 成為孩子的學習教練",
    "summary": "光看是學不會技能中最困難的部分。講者提出把 AI 當作「教練」——提供循序漸進的練習、糾正錯誤——家長的角色是陪伴孩子在嘗試與修正中成長，而非讓 AI 直接給出答案。",
    "title_zhHant": "讓 AI 成為孩子的學習教練",
    "title_zhHans": "让 AI 成为孩子的学习教练",
    "title_en": "Let AI Be Your Child's Learning Coach",
    "summary_zhHant": "光看是學不會技能中最困難的部分。講者提出把 AI 當作「教練」——提供循序漸進的練習、糾正錯誤——家長的角色是陪伴孩子在嘗試與修正中成長，而非讓 AI 直接給出答案。",
    "summary_zhHans": "光看是学不会技能中最困难的部分。讲者提出把 AI 当作「教练」——提供循序渐进的练习、纠正错误——家长的角色是陪伴孩子在尝试与修正中成长，而非让 AI 直接给出答案。",
    "summary_en": "Watching alone is the hardest part of learning any skill. The speaker proposes treating AI as a \"coach\"—offering step-by-step practice and correcting mistakes—while parents' role is to accompany their children through trial and correction, not to let AI hand out answers directly.",
    "host_zhHant": "亞斯理衞理小學",
    "host_zhHans": "亚斯理衞理小学",
    "host_en": "Asbury Methodist Primary School",
    "venue_zhHant": "亞斯理衞理小學",
    "venue_zhHans": "亚斯理衞理小学",
    "venue_en": "Asbury Methodist Primary School",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/99d7ed84-8c4d-4761-8da9-ed6ed72b2dc0.medium.webp",
    "photo1_width": 1024,
    "photo1_height": 768,
    "photo1_alt_zhHant": "亞斯理衞理小學家長講座現場",
    "photo1_alt_zhHans": "亚斯理衞理小学家长讲座现场",
    "photo1_alt_en": "A parents' talk held at Asbury Methodist Primary School.",
    "photo2_url": "",
    "photo2_width": null,
    "photo2_height": null,
    "photo2_alt_zhHant": "",
    "photo2_alt_zhHans": "",
    "photo2_alt_en": "",
    "meta_title_zhHant": "讓 AI 成為孩子的學習教練",
    "meta_title_zhHans": "让 AI 成为孩子的学习教练",
    "meta_title_en": null,
    "meta_description_zhHant": "光看是學不會技能中最困難的部分。講者提出把 AI 當作「教練」——提供循序漸進的練習、糾正錯誤——家長的角色是陪伴孩子在嘗試與修正中成長，而非讓 AI 直接給出答案。",
    "meta_description_zhHans": "光看是学不会技能中最困难的部分。讲者提出把 AI 当作「教练」——提供循序渐进的练习、纠正错误——家长的角色是陪伴孩子在尝试与修正中成长，而非让 AI 直接给出答案。",
    "meta_description_en": "YADA Executive Director Wei Yuanqiang joined an Asbury Methodist teacher session on Hong Kong media literacy and the role of schools in online safety education.",
    "external_url": null,
    "venue_url": "https://www.asbury.edu.hk/",
    "published_at": 1791797424422
  },
  {
    "slug": "2026-10-02-mong-yung-online-safety-lecture",
    "audience": "teacher",
    "speaker": "魏遠強先生 / Mr. Ngai-Wai Wai",
    "event_date": "2026-10-02",
    "title": "從「監控者」到「網絡安全教練」 — 魏遠強總監走進蒙養學校",
    "summary": "魏遠強總監應《香港01》邀請到錦田公立蒙養學校主講網絡安全教師講座，提出由「監控者」轉型為「網絡安全教練」的四步防騙閉環。",
    "title_zhHant": "從「監控者」到「網絡安全教練」 — 魏遠強總監走進蒙養學校",
    "title_zhHans": "从「监控者」到「网络安全教练」 — 魏远强总监走进蒙养学校",
    "title_en": "From Watchdog to Net-Safety Coach — Mr. Wai Visits Mong Yung School",
    "summary_zhHant": "魏遠強總監應《香港01》邀請到錦田公立蒙養學校主講網絡安全教師講座，提出由「監控者」轉型為「網絡安全教練」的四步防騙閉環。",
    "summary_zhHans": "魏远强总监应《香港01》邀请到锦田公立蒙养学校主讲网络安全教师讲座，提出由「监控者」转型为「网络安全教练」的四步防骗闭环。",
    "summary_en": "Mr. Ngai-Wai Wai urged primary-school teachers to move from surveillance to net-safety coaching in a 2 Oct HK01 talk at Mong Yung Public School.",
    "host_zhHant": "《香港01》「01教育」",
    "host_zhHans": "《香港01》「01教育」",
    "host_en": "HK01 \"01 Education\"",
    "venue_zhHant": "錦田公立蒙養學校",
    "venue_zhHans": "锦田公立蒙养学校",
    "venue_en": "Kam Tin Public School (Mong Yung)",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/7448fd81-7bb5-49e8-9e98-c80595fd0604.medium.webp",
    "photo1_width": 4096,
    "photo1_height": 3072,
    "photo1_alt_zhHant": "從「監控者」到「網絡安全教練」 — 魏遠強總監走進蒙養學校",
    "photo1_alt_zhHans": "从「监控者」到「网络安全教练」 — 魏远强总监走进蒙养学校",
    "photo1_alt_en": "From Watchdog to Net-Safety Coach — Mr. Wai Visits Mong Yung School",
    "photo2_url": "/uploads/2026-10/33f9d308-fe1a-4fd3-af7b-a55fd2175d75.medium.webp",
    "photo2_width": 3072,
    "photo2_height": 2838,
    "photo2_alt_zhHant": "魏遠強總監與蒙養學校教師合照",
    "photo2_alt_zhHans": "魏远强总监与蒙养学校教师合照",
    "photo2_alt_en": "Group photo with the principal and teachers at Mong Yung Public School",
    "meta_title_zhHant": "從「監控者」到「網絡安全教練」 — 魏遠強總監走進蒙養學校",
    "meta_title_zhHans": "从「监控者」到「网络安全教练」 — 魏远强总监走进蒙养学校",
    "meta_title_en": "From Watchdog to Net-Safety Coach",
    "meta_description_zhHant": "魏遠強總監應《香港01》邀請到錦田公立蒙養學校主講網絡安全教師講座，提出由「監控者」轉型為「網絡安全教練」的四步防騙閉環。",
    "meta_description_zhHans": "魏远强总监应《香港01》邀请到锦田公立蒙养学校主讲网络安全教师讲座，提出由「监控者」转型为「网络安全教练」的四步防骗闭环。",
    "meta_description_en": "Mr. Ngai-Wai Wai urged primary teachers to move from surveillance to net-safety coaching in a 2 Oct HK01 talk at Mong Yung Public School.",
    "external_url": null,
    "venue_url": "https://www.ktmy.edu.hk/",
    "published_at": 1791540529694
  },
  {
    "slug": "yck-20260911",
    "audience": "teacher",
    "speaker": "魏遠強先生",
    "event_date": "2026-09-11",
    "title": "孩子出事，成人總是最後一個知道 — 余振強紀念中學教師講座紀錄",
    "summary": "2026 年 9 月 11 日，魏遠強先生應《香港01》邀請，於余振強紀念中學主講「拆解學生常遇網上騙案陷阱：新媒體下成人角色」教師場講座。本文依據 HK 警務處「守網者」最新數據，拆解四大高危騙案與 AI 深偽威脅，並提出「預防、識別、應對、支援」閉環框架與家校合作機制，呼籲成人從「監控者」轉型為「網絡安全教練」。",
    "title_zhHant": "孩子出事，成人總是最後一個知道 — 余振強紀念中學教師講座紀錄",
    "title_zhHans": "孩子出事，成人总是最后一个知道 — 余振强纪念中学教师讲座纪录",
    "title_en": "When kids get hurt, adults are the last to know — notes from the Yu Chun Keung Memorial College teacher session",
    "summary_zhHant": "2026 年 9 月 11 日，魏遠強先生應《香港01》邀請，於余振強紀念中學主講「拆解學生常遇網上騙案陷阱：新媒體下成人角色」教師場講座。本文依據 HK 警務處「守網者」最新數據，拆解四大高危騙案與 AI 深偽威脅，並提出「預防、識別、應對、支援」閉環框架與家校合作機制，呼籲成人從「監控者」轉型為「網絡安全教練」。",
    "summary_zhHans": "2026 年 9 月 11 日，魏远强先生应《香港01》邀请，于余振强纪念中学主讲「拆解学生常遇网上骗案陷阱：新媒体下成人角色」教师场讲座。本文依据 HK 警务处「守网者」最新数据，拆解四大高危骗案与 AI 深伪威胁，并提出「预防、识别、应对、支援」闭环框架与家校合作机制，呼吁成人从「监控者」转型为「网络安全教练」。",
    "summary_en": "On 11 September 2026, Mr. Wei Yuanqiang was invited by HK01 to deliver the teacher session of \"Online scams targeting students: adult roles in the new media era\" at Yu Chun Keung Memorial College. Drawing on Hong Kong Police Force 'Cyber Defender' data, the talk unpacks four high-risk scam patterns and the new AI deepfake threat, then proposes a prevent–recognise–respond–support closed-loop framework and a home–school cooperation mechanism — calling on adults to step from 'monitor' to 'cybersecurity coach'.",
    "host_zhHant": "《香港01》",
    "host_zhHans": "《香港01》",
    "host_en": "HK01",
    "venue_zhHant": "余振強紀念中學",
    "venue_zhHans": "余振强纪念中学",
    "venue_en": "Yu Chun Keung Memorial College",
    "series_zhHant": "三場講座連續 — 拆解學生常遇網上騙案陷阱：新媒體下成人角色",
    "series_zhHans": "三场讲座连续 — 拆解学生常遇网上骗案陷阱：新媒体下成人角色",
    "series_en": "Three-part lecture series — Online scams targeting students: adult roles in the new-media era",
    "photo1_url": "/media/lectures/yck-20260911/photo-1.jpg",
    "photo1_width": 1600,
    "photo1_height": 1067,
    "photo1_alt_zhHant": "魏遠強先生於余振強紀念中學主講台上，講解學生常遇的網絡詐騙趨勢。",
    "photo1_alt_zhHans": "魏远强先生于余振强纪念中学主讲台上，讲解学生常遇的网络诈骗趋势。",
    "photo1_alt_en": "Mr. Wei Yuanqiang on stage at Yu Chun Keung Memorial College, presenting online-fraud trends affecting students.",
    "photo2_url": "/media/lectures/yck-20260911/photo-2.jpg",
    "photo2_width": 1600,
    "photo2_height": 1067,
    "photo2_alt_zhHant": "講座現場，教師席聆聽學生網騙案例的實況。",
    "photo2_alt_zhHans": "讲座现场，教师席聆听学生网骗案例的实况。",
    "photo2_alt_en": "In-room view: teachers in the audience listening to the student-scam case studies.",
    "meta_title_zhHant": "孩子出事，成人總是最後一個知道 — 余振強紀念中學教師講座紀錄",
    "meta_title_zhHans": "孩子出事，成人总是最后一个知道 — 余振强纪念中学教师讲座纪录",
    "meta_title_en": "Online Scams: Adults Last to Know",
    "meta_description_zhHant": "2026 年 9 月 11 日，魏遠強先生應《香港01》邀請，於余振強紀念中學主講「拆解學生常遇網上騙案陷阱：新媒體下成人角色」教師場講座。本文依據 HK 警務處「守網者」最新數據，拆解四大高危騙案與 AI 深偽威脅，並提出「預防、識別、應對、支援」閉環框架與家校合作機制，呼籲成人從「監控者」轉型為「網絡安全教練」。",
    "meta_description_zhHans": "2026 年 9 月 11 日，魏远强先生应《香港01》邀请，于余振强纪念中学主讲「拆解学生常遇网上骗案陷阱：新媒体下成人角色」教师场讲座。本文依据 HK 警务处「守网者」最新数据，拆解四大高危骗案与 AI 深伪威胁，并提出「预防、识别、应对、支援」闭环框架与家校合作机制，呼吁成人从「监控者」转型为「网络安全教练」。",
    "meta_description_en": "YADA's Wei Yuanqiang led the teacher session at Yu Chun Keung Memorial College on adults' role in the new-media era of student-targeted scams.",
    "external_url": null,
    "venue_url": "https://www.yckmc.edu.hk/",
    "published_at": 1757529600000
  },
  {
    "slug": "ylcc-primary-20260905",
    "audience": "parent",
    "speaker": "魏遠強（YADA 行政總監）",
    "event_date": "2026-09-05",
    "title": "親子同行 × 健康使用 AI",
    "summary": "研究顯示用 AI 做作業雖令作業成績提升 18%，但六個月內月考成績下降 20%。講者提出五項引導孩子使用 AI 的策略，核心是陪伴孩子駕馭 AI，而非被 AI 取代思考。",
    "title_zhHant": "親子同行 × 健康使用 AI",
    "title_zhHans": "亲子同行 × 健康使用 AI",
    "title_en": "Parents and Children Together × Healthy Use of AI",
    "summary_zhHant": "研究顯示用 AI 做作業雖令作業成績提升 18%，但六個月內月考成績下降 20%。講者提出五項引導孩子使用 AI 的策略，核心是陪伴孩子駕馭 AI，而非被 AI 取代思考。",
    "summary_zhHans": "研究显示用 AI 做作业虽令作业成绩提升 18%，但六个月内月考成绩下降 20%。讲者提出五项引导孩子使用 AI 的策略，核心是陪伴孩子驾驭 AI，而非被 AI 取代思考。",
    "summary_en": "Research shows that while using AI for homework raises assignment scores by 18%, monthly exam scores drop by 20% within six months. The speaker proposed five strategies for guiding children in using AI, with the core message being to accompany children in mastering AI rather than letting AI replace their thinking.",
    "host_zhHant": "元朗商會小學",
    "host_zhHans": "元朗商会小学",
    "host_en": "Yuen Long Merchants Association Primary School",
    "venue_zhHant": "元朗商會小學",
    "venue_zhHans": "元朗商会小学",
    "venue_en": "Yuen Long Merchants Association Primary School",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/56502cd5-2e6c-4bb2-8c96-ac2e848604b9.medium.webp",
    "photo1_width": 1024,
    "photo1_height": 576,
    "photo1_alt_zhHant": "元朗商會小學家長講座現場",
    "photo1_alt_zhHans": "元朗商会小学家长讲座现场",
    "photo1_alt_en": "Parent talk venue at Yuen Long Merchants Association Primary School",
    "photo2_url": "/uploads/2026-10/a69f4763-ac15-4ca9-b49b-ad1859f15bd4.medium.webp",
    "photo2_width": 1024,
    "photo2_height": 576,
    "photo2_alt_zhHant": "大批家長出席講座",
    "photo2_alt_zhHans": "大批家长出席讲座",
    "photo2_alt_en": "Large number of parents attending the talk",
    "meta_title_zhHant": "親子同行 × 健康使用 AI",
    "meta_title_zhHans": "亲子同行 × 健康使用 AI",
    "meta_title_en": "Parents & Children: Healthy Use of AI",
    "meta_description_zhHant": "研究顯示用 AI 做作業雖令作業成績提升 18%，但六個月內月考成績下降 20%。講者提出五項引導孩子使用 AI 的策略，核心是陪伴孩子駕馭 AI，而非被 AI 取代思考。",
    "meta_description_zhHans": "研究显示用 AI 做作业虽令作业成绩提升 18%，但六个月内月考成绩下降 20%。讲者提出五项引导孩子使用 AI 的策略，核心是陪伴孩子驾驭 AI，而非被 AI 取代思考。",
    "meta_description_en": "AI for homework raises scores by 18% but monthly exams drop 20% within six months. Five strategies for guiding children's AI use.",
    "external_url": null,
    "venue_url": "https://www.ylmaps.edu.hk/",
    "published_at": 1791797424305
  },
  {
    "slug": "la-salle-20260819",
    "audience": "teacher",
    "speaker": "魏遠強（YADA 執行總監）",
    "event_date": "2026-08-19",
    "title": "正向教育培訓：以全校參與模式培育學生品格優勢",
    "summary": "YADA 執行總監應邀到喇沙中學為全體教師及職員進行正向教育培訓，講解正向教育的理論與原則，並以「微時刻教學」示範如何提升學生的成長型思維；同時介紹如何結合線上線下模式及 AI 輔助系統，將正向校園文化持續深化。",
    "title_zhHant": "正向教育培訓：以全校參與模式培育學生品格優勢",
    "title_zhHans": "正向教育培训：以全校参与模式培育学生品格优势",
    "title_en": "Positive Education Training: Nurturing Students' Character Strengths through a Whole-School Approach",
    "summary_zhHant": "YADA 執行總監應邀到喇沙中學為全體教師及職員進行正向教育培訓，講解正向教育的理論與原則，並以「微時刻教學」示範如何提升學生的成長型思維；同時介紹如何結合線上線下模式及 AI 輔助系統，將正向校園文化持續深化。",
    "summary_zhHans": "YADA 执行总监应邀到喇沙中学为全体教师及职员进行正向教育培训，讲解正向教育的理论与原则，并以「微时刻教学」示范如何提升学生的成长型思维；同时介绍如何结合线上线下模式及 AI 辅助系统，将正向校园文化持续深化。",
    "summary_en": "The Executive Director of YADA was invited to La Salle College to conduct positive education training for all teachers and staff. The session covered the theory and principles of positive education, with demonstrations of \"micro-moment teaching\" to enhance students' growth mindset. It also introduced ways to combine online and offline models with AI-assisted systems to sustain and deepen a positive school culture.",
    "host_zhHant": "喇沙中學",
    "host_zhHans": "喇沙中学",
    "host_en": "La Salle College",
    "venue_zhHant": "喇沙中學",
    "venue_zhHans": "喇沙中学",
    "venue_en": "La Salle College",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/0404b8e5-a46f-4e28-9d23-6245effe0b77.medium.webp",
    "photo1_width": 1380,
    "photo1_height": 776,
    "photo1_alt_zhHant": "喇沙中學教師正向教育培訓現場",
    "photo1_alt_zhHans": "喇沙中学教师正向教育培训现场",
    "photo1_alt_en": "Positive education training session for teachers at La Salle College",
    "photo2_url": "",
    "photo2_width": null,
    "photo2_height": null,
    "photo2_alt_zhHant": "",
    "photo2_alt_zhHans": "",
    "photo2_alt_en": "",
    "meta_title_zhHant": "正向教育培訓：以全校參與模式培育學生品格優勢",
    "meta_title_zhHans": "正向教育培训：以全校参与模式培育学生品格优势",
    "meta_title_en": "Positive Education Training at La Salle",
    "meta_description_zhHant": "YADA 執行總監應邀到喇沙中學為全體教師及職員進行正向教育培訓，講解正向教育的理論與原則，並以「微時刻教學」示範如何提升學生的成長型思維；同時介紹如何結合線上線下模式及 AI 輔助系統，將正向校園文化持續深化。",
    "meta_description_zhHans": "YADA 执行总监应邀到喇沙中学为全体教师及职员进行正向教育培训，讲解正向教育的理论与原则，并以「微时刻教学」示范如何提升学生的成长型思维；同时介绍如何结合线上线下模式及 AI 辅助系统，将正向校园文化持续深化。",
    "meta_description_en": "YADA's Executive Director trained La Salle College teachers on positive education, character strengths, and micro-moment teaching.",
    "external_url": null,
    "venue_url": "https://www.lasalle.edu.hk/",
    "published_at": 1791938251762
  },
  {
    "slug": "jc-perform-arts-20260817",
    "audience": "parent",
    "speaker": "魏遠強（青年耀進發展協會行政總監）",
    "event_date": "2026-08-17",
    "title": "AI 時代的家長角色：成為孩子的「副駕駛」",
    "summary": "青少年處於「此時此刻」的心理狀態，AI 快速、不需思考的回應方式容易令孩子對 AI 產生依賴；家長在價值觀、風險管理與自制能力上比孩子成熟，正是「副駕駛」角色的關鍵所在。",
    "title_zhHant": "AI 時代的家長角色：成為孩子的「副駕駛」",
    "title_zhHans": "AI 时代的家长角色：成为孩子的「副驾驶」",
    "title_en": "Parental Roles in the AI Era: Becoming Your Child's \"Co-Pilot\"",
    "summary_zhHant": "青少年處於「此時此刻」的心理狀態，AI 快速、不需思考的回應方式容易令孩子對 AI 產生依賴；家長在價值觀、風險管理與自制能力上比孩子成熟，正是「副駕駛」角色的關鍵所在。",
    "summary_zhHans": "青少年处于「此时此刻」的心理状态，AI 快速、不需思考的回应方式容易令孩子对 AI 产生依赖；家长在价值观、风险管理与自制能力上比孩子成熟，正是「副驾驶」角色的关键所在。",
    "summary_en": "Adolescents inhabit a \"here and now\" psychological state, and AI's fast, thought-free responses can easily lead children to become dependent on AI. Parents are more mature than their children in values, risk management and self-discipline — precisely why the \"co-pilot\" role is so critical.",
    "host_zhHant": "賽馬會體藝中學",
    "host_zhHans": "赛马会体艺中学",
    "host_en": "Jockey Club Ti-I College",
    "venue_zhHant": "賽馬會體藝中學",
    "venue_zhHans": "赛马会体艺中学",
    "venue_en": "Jockey Club Ti-I College",
    "series_zhHant": "",
    "series_zhHans": "",
    "series_en": "",
    "photo1_url": "/uploads/2026-10/ff250b9e-dc34-4a9a-a785-abaf38260c17.medium.webp",
    "photo1_width": 1024,
    "photo1_height": 682,
    "photo1_alt_zhHant": "魏遠強先生向家長講解 AI 對青少年學習的影響",
    "photo1_alt_zhHans": "魏远强先生向家长讲解 AI 对青少年学习的影响",
    "photo1_alt_en": "Mr. Wei Yuanqiang explains to parents how AI affects adolescent learning.",
    "photo2_url": "/uploads/2026-10/9873a722-d8c5-442a-82c5-df730a686e12.medium.webp",
    "photo2_width": 1024,
    "photo2_height": 682,
    "photo2_alt_zhHant": "家長講座現場情況",
    "photo2_alt_zhHans": "家长讲座现场情况",
    "photo2_alt_en": "Parents attending the lecture on-site.",
    "meta_title_zhHant": "AI 時代的家長角色：成為孩子的「副駕駛」",
    "meta_title_zhHans": "AI 时代的家长角色：成为孩子的「副驾驶」",
    "meta_title_en": "Parents as Co-Pilots in the AI Era",
    "meta_description_zhHant": "青少年處於「此時此刻」的心理狀態，AI 快速、不需思考的回應方式容易令孩子對 AI 產生依賴；家長在價值觀、風險管理與自制能力上比孩子成熟，正是「副駕駛」角色的關鍵所在。",
    "meta_description_zhHans": "青少年处于「此时此刻」的心理状态，AI 快速、不需思考的回应方式容易令孩子对 AI 产生依赖；家长在价值观、风险管理与自制能力上比孩子成熟，正是「副驾驶」角色的关键所在。",
    "meta_description_en": "Adolescents' 'here and now' mindset and AI's instant answers breed dependency. Parents should become co-pilots, leading on values and risk.",
    "external_url": null,
    "venue_url": "https://www.tic.edu.hk/",
    "published_at": 1791797424182
  }
]
